module.exports = __webpack_public_path__ + "bb2c6f2c4af81754f8a4660dc9b58786.png";